<template>
    <div>
        <RadioGroup v-if="isSingleSelect" :slug="slug" :description="description" :isSmallLabel="isSmallLabel" :filterValues="filterValues" :label="title" :showNumResults="true" @radioChange="onFilterChange"> </RadioGroup>
        <CheckboxGroup v-else :slug="slug" :isSmallLabel="isSmallLabel" :description="description" :filterValues="filterValues" :label="title" :showNumResults="true" @filterChange="onFilterChange"></CheckboxGroup>
    </div>
</template>

<script lang="ts">
import { FilterValue } from 'Vue/interfaces/LockDesigner';
import CheckboxGroup from './CheckboxGroup.vue';
import RadioGroup from './RadioGroup.vue';
export default {
    name: 'Checkbox',
    props: {
        slug: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        displayExpanded: {
            type: Boolean,
            default: false,
        },
        isSingleSelect: {
            type: Boolean,
            default: false,
        },
        hasFilters: {
            type: Boolean,
            default: false,
        },
        filterValues: {
            type: Array,
            required: true,
        },
        isSmallLabel: {
            type: Boolean,
            default: false,
        },
        description: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            selectedValue: null, // Track the selected value
        };
    },
    methods: {
        onFilterChange(filterValues: FilterValue[]) {
            this.$emit('filterChange', { slug: this.slug, filterValues });
        },
        onInfoButtonClick() {
            this.$emit('infoButtonClick');
        },
    },
    components: { CheckboxGroup, RadioGroup },
};
</script>
